import { render, staticRenderFns } from "./currencyRedemption.vue?vue&type=template&id=235bd456&scoped=true"
import script from "./currencyRedemption.vue?vue&type=script&lang=js"
export * from "./currencyRedemption.vue?vue&type=script&lang=js"
import style0 from "./currencyRedemption.vue?vue&type=style&index=0&id=235bd456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235bd456",
  null
  
)

export default component.exports